<bb-loading-indicator-ui
  loaderSize="lg"
  [showDelay]="750"
  text="Loading..."
></bb-loading-indicator-ui>
